// Cookies Popin
export function cookiesPopup() {
    showHideCookiesPopup();
}

function showHideCookiesPopup() {
    const popup = document.querySelector('.stickyCookies');
    const closeBtn = document.querySelector('.js__close-cookies');

    // Close Popup and track current time
    function closePopup() {
        popup.classList.remove('visible');
        localStorage.setItem('cookiesSticky', Date.now());
    }
    
    // Function to check and show the popup
    function checkAndShowPopup() {
        let popupClosedTime = localStorage.getItem('cookiesSticky');
        let currentTime = Date.now();

        // Check if popup has never been closed or more than 24 hours have passed
        if (currentTime - popupClosedTime >= 24 * 60 * 60 * 1000) {
            popup.classList.add('visible');
        }

        // Attach event listener for close button
        closeBtn.addEventListener('click', closePopup);
    }

    // Call the checkAndShowPopup function when the page loads
    window.addEventListener('load', checkAndShowPopup);

}
